export default "https://cdn-static.gokick.com/assets/2b3e6896c425e2cf7d1a83db5abe7919e5484d77/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";